import React from 'react';

import { lazyLoad } from 'utils/loadable';

import { LanguageSelector } from '../components/translate/LanguageSelector';

const LoginComponent: React.FC<any> = (props) => {
  return (
    <div className="w-100 vh-100 login">
      <LanguageSelector />
      {props.children}
    </div>
  );
};

export const Default = React.memo(LoginComponent);

export const LoginLayout = lazyLoad(
  () => import('../layouts/login'),
  (module) => module.Default
);
